module.exports = __webpack_public_path__ + "static/azubu-e3-573c8542cec23b02c571bd494e6e0f5a.mp4";